import Activity from '../activity';

/**
 * Create the action
 */

const { thunk, request, success, error } = Activity.index((fetch) => {
    return fetch.get('/activities');
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
